import { SplitModeProvider } from '../SplitModeProvider';

type PanelGroupProviderProps = {
  /**
   * The unique identifier for the panel group.
   */
  panelGroupId: number;
  /**
   * The children to render.
   */
  children: React.ReactNode;
};

/**
 * Consolidates all panel group related providers.
 */
export function PanelGroupProvider(props: PanelGroupProviderProps) {
  const { children, panelGroupId } = props;

  // Other future panel group specific providers can go here.
  return <SplitModeProvider panelGroupId={panelGroupId}>{children}</SplitModeProvider>;
}
